/* The above code is a map of all the fields that can be used in the form. */
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import FieldTypes from "../../Types/FieldTypes"
import formReggie from "../../Utils/FormReggie"
import CommentsField from "./CommentsField/CommentsField"
import DateField from "./DateField/DateField"
import DropDownField from "./DropDownField/DropDownField"
import MultiSelectField from "./MultiSelectField/MultiSelectField"
import NotFound from "./NotFound/NotFound"
import NumberField from "./NumberField/NumberField"
import ScannerField from "./ScannerField/ScannerField"
import Section from "./Section/Section"
import SignatureField from "./SignatureField/SignatureField"
import StaticText from "./StaticText/StaticText"
import TextField from "./TextField/TextField"
import TimeField from "./TimeField/TimeField"
import YesOrNoField from "./YesOrNoField/YesOrNoField"
import ImageSketchField from "./ImageSketch/ImageSketchField"
import SamsaraS3VideoWrapper from "./SamsaraS3Video/SamsaraS3VideoWrapper"

const triggers =
    [
        ["Validator", "validators"],
        ["Formatter", "formatters"]
    ]

const fieldMap = {
    /* A function that returns a React component. */
    buildField: (type: string | null, row: number, col: number, template: Array<Array<FieldTypes>> | [], palette: Array<DynamicFormPaletteTypes>, handleChange: Function, manageParentState: Function, remove: Function, templateField?: boolean, readOnly?: boolean) => {
        const field = template[row][col]
        const fieldProps = { ...{ field: field }, ...{ palette: palette, handleChange: handleChange, manageParentState: manageParentState, row: row, col: col, templateField: templateField, remove: remove, readOnly } }
        const newField = fieldMap.fields.filter(obj => { return obj.type === type })[0] || fieldMap.fields[0]
        return newField.component(fieldProps)
    },
    /* A function that returns a React component. */
    buildConfigField: (field: FieldTypes, palette: Array<DynamicFormPaletteTypes>, row: number, col: number, handleChange: Function, manageParentState: Function, remove: Function, readOnly?: boolean) => {
        const f = field
        const fieldProps = { ...{ field: f }, ...{ palette: palette, handleChange: handleChange, manageParentState: manageParentState, row: row, col: col, remove: remove, configField: true, readOnly } }
        const newField = fieldMap.fields.filter(obj => { return obj.type === f.Type })[0]
        return newField
            ? { field: newField.component(fieldProps), configHelper: newField.configHelper }
            : { field: fieldMap.fields[0].component(fieldProps), configHelper: fieldMap.fields[0].configHelper }
    },
    fields: [
        /* A fallback for when the field type is not found. */
        {   //!!!!do not move this away from the first index
            type: "Not Found",
            component: NotFound,
            configHelper: {
                fieldType: "notFound",
                triggers: triggers,
                validators: [],
                formatters: [],
            }
        },
        /* A field type. */
        {
            type: "Number",
            component: NumberField,
            configHelper: {
                fieldType: "number",
                triggers: triggers,
                validators: [],
                formatters: [],
            }
        },
        {
            type: "Text",
            component: TextField,
            configHelper: {
                fieldType: "text",
                triggers: triggers,
                validators: [
                    {
                        type: "Valid Email",
                        validator: formReggie.validateMail
                    },
                    {
                        type: "Valid Phone",
                        validator: formReggie.validatePhone
                    },
                    {
                        type: "Valid Date",
                        validator: formReggie.isDate
                    },
                    {
                        type: "Valid URL",
                        validator: formReggie.isURL
                    },
                ],
                formatters: [
                    {
                        type: "Phone",
                        formatter: formReggie.formatPhone
                    },
                    {
                        type: "Title Case",
                        formatter: formReggie.titleCase
                    },
                    {
                        type: "All Caps",
                        formatter: formReggie.allCaps
                    },
                    {
                        type: "Lowercase",
                        formatter: formReggie.lowercase
                    },
                ],
            }
        },
        {
            type: "Drop Down",
            component: DropDownField,
            configHelper: {
                fieldType: "dropDown",
                triggers: triggers,
                validators: [],
                formatters: []
            }
        },

        {
            type: "MultiSelect",
            component: MultiSelectField,
            configHelper: {
                fieldType: "multiSelectDropDown",
                triggers: triggers,
                validators: [],
                formatters: []
            }
        },
        {
            type: "Yes or No",
            component: YesOrNoField,
            configHelper: {
                fieldType: "yesOrNo",
                triggers: triggers,
                validators: [],
                formatters: []
            }
        },
        {
            type: "Signature",
            component: SignatureField,
            configHelper: {
                fieldType: "signature",
                triggers: triggers,
                validators: [],
                formatters: []
            }
        },
        {
            type: "Date",
            component: DateField,
            configHelper: {
                fieldType: "date",
                triggers: triggers,
                validators: [],
                formatters: []
            }
        },
        {
            type: "Time",
            component: TimeField,
            configHelper: {
                fieldType: "time",
                triggers: triggers,
                validators: [],
                formatters: []
            }
        },
        {
            type: "StaticText",
            component: StaticText,
            configHelper: {
                fieldType: "staticText",
                triggers: triggers,
                validators: [],
                formatters: []
            }
        },
        {
            type: "Comments",
            component: CommentsField,
            configHelper: {
                fieldType: "comments",
                triggers: triggers,
                validators: [],
                formatters: []
            }
        },
        {
            type: "Section",
            component: Section,
            configHelper: {
                fieldType: "section",
                triggers: triggers,
                validators: [],
                formatters: []
            }
        },
        {
            type: "Scanner",
            component: ScannerField,
            configHelper: {
                fieldType: "scanner",
                triggers: triggers,
                validators: [],
                formatters: []
            }
        },
        {
            type: "ImageSketch",
            component: ImageSketchField,
            configHelper: {
                fieldType: "imageSketch",
                triggers: triggers,
                validators: [],
                formatters: []
            }
        },
        {
            type: "SamsaraS3Video",
            component: SamsaraS3VideoWrapper,
            configHelper: {
                fieldType: "samsaraS3Video",
                triggers: triggers,
                validators: [],
                formatters: []
            }
        }
    ]
}


export default fieldMap